import React from 'react';

import DraftManualGIQProvider from './context';
import DraftManualGIQList from './List';

const DraftManualGIQ: React.FC = () => {
  return (
    <DraftManualGIQProvider>
      <DraftManualGIQList />
    </DraftManualGIQProvider>
  );
};

export default DraftManualGIQ;
